/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateVerificationDto = {
    /**
     * Verification status
     */
    status: UpdateVerificationDto.status;
    /**
     * Verification notes (required when status is rejected)
     */
    notes?: string;
};
export namespace UpdateVerificationDto {
    /**
     * Verification status
     */
    export enum status {
        PENDING = 'pending',
        IN_PROGRESS = 'in_progress',
        VERIFIED = 'verified',
        REJECTED = 'rejected',
        RESUBMISSION_REQUIRED = 'resubmission_required',
    }
}

